import PropTypes from 'prop-types';
import { Col, message, Row } from 'antd';
import { JaaSMeeting, JitsiMeeting } from '@jitsi/react-sdk';

import { BaseComponent } from 'src/components';
import { lib } from 'src/Utils';

const UNIQUE_APP_ID = "timewiseid-i-0c69ab3f8751ba70c"
const JITSI_APP_ID = "vpaas-magic-cookie-d8eb02782fda40d089fd1e040d318191"
const JITSI_TOOLBAR_BUTTONS = [
               'camera',
               'chat',
              //  'closedcaptions',
               'desktop',
              //  'download',
              //  'embedmeeting',
               'etherpad',
              //  'feedback',
               'filmstrip',
               'fullscreen',
               'hangup',
               'help',
               'highlight',
              //  'invite',
              //  'linktosalesforce',
               'livestreaming',
               'microphone',
               'noisesuppression',
               'participants-pane',
              //  'profile',
               'raisehand',
               'recording',
               'security',
               'select-background',
               'settings',
              //  'shareaudio',
              //  'sharedvideo',
               'shortcuts',
              //  'stats',
               'tileview',
               'toggle-camera',
               'videoquality',
               'whiteboard',
            ]

class MeetingContent extends BaseComponent {
  constructor(props) {
    super(props)

    console.log('currentUser', lib.ls.getCurrentUser())
    this.myProfile = lib.ls.getCurrentUser()
  }

  render() {
    console.log('Rendered', this)

    const jitsyBody = {
      aud: 'jitsi',
      context: {
        user: {
          name: lib.getFullName(this.myProfile),
          email: this.myProfile?.email,
          avatar: this.myProfile?.photo,
          moderator: true,
        },
        features: {
          recording: true,
          moderation: true,
        },
      },
      exp: Math.floor(new Date().getTime() / 1000) + (60 * 60),

      iss: 'chat',
      room: this.props.room,
      sub: JITSI_APP_ID,
    }

    console.log('jitsyBody', jitsyBody)

    // const secret = '728159b0dce9284622f59baad6de92c370b8291fe203509f6fa649b1f98af43e8251ff0f1d5a0137f4da26a12078a382ad9ef8fbe5c87eef49f57f6072d766f6ad3b15f33c3b73cf37751bc29ed78bbb9507fc8a6b1351fd3ca67be366e76e5e9e5a4ff21c69cd96ac4c9e7469aa7d3cb0b43303072b3b4f5b45bb42571761244d35908f85944378386e5c5fa8f3e28d45197e9ffceeab516061e67aca2cd47f0c28cc52bd7ff4c64d1ae8e7b3b0809c6abdb5f10a15eb52fd408edcfbb4b59ac59cd6b8504f39a2b341928d5c1dc68b41c93883d72e6013dd73c4a7cbeb1d5f445af3935cdc198476950bbd0a31d687275b87e75e9937b0d6e0a3ebda2cdabe'
    // const token = jwt.sign(jitsyBody, secret, { algorithm: 'HS256' })
    // console.log('token', token)

    const token = 'eyJraWQiOiJ2cGFhcy1tYWdpYy1jb29raWUtZDhlYjAyNzgyZmRhNDBkMDg5ZmQxZTA0MGQzMTgxOTEvN2E0MWNkLVNBTVBMRV9BUFAiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiJqaXRzaSIsImlzcyI6ImNoYXQiLCJpYXQiOjE3Mzg3MzEzNDYsImV4cCI6MTczODczODU0NiwibmJmIjoxNzM4NzMxMzQxLCJzdWIiOiJ2cGFhcy1tYWdpYy1jb29raWUtZDhlYjAyNzgyZmRhNDBkMDg5ZmQxZTA0MGQzMTgxOTEiLCJjb250ZXh0Ijp7ImZlYXR1cmVzIjp7ImxpdmVzdHJlYW1pbmciOnRydWUsIm91dGJvdW5kLWNhbGwiOnRydWUsInNpcC1vdXRib3VuZC1jYWxsIjpmYWxzZSwidHJhbnNjcmlwdGlvbiI6dHJ1ZSwicmVjb3JkaW5nIjp0cnVlfSwidXNlciI6eyJoaWRkZW4tZnJvbS1yZWNvcmRlciI6ZmFsc2UsIm1vZGVyYXRvciI6dHJ1ZSwibmFtZSI6ImRldiIsImlkIjoiYXV0aDB8Njc5ZGQwYWI0MzE2ZjRkMDZmYzk2NTVlIiwiYXZhdGFyIjoiIiwiZW1haWwiOiJkZXZAb25laHViLm5ldCJ9fSwicm9vbSI6IioifQ.aClVnnJ6Ww4mGwcPPzccXHkETVbe4cTRTBPhtq9EDZzvxApVfAcaQGYtWMFH1lMKDFpLVFRhYsP2nNuroHDH1LAAt5O3RnyXctIuK5DHgplxGMQhEQIUNV6D5QOcYxvYXtM6Ayi-NLSdi6C_0Pa8MPG9RzE6o6a1Z5vzAoFhbJ6DVBgKijiehN6QpyGYyozfAitBs5D9UEh4rMaG9-GPLkTProRPnlAu1Z6FiBtEBo1xR2s3TZXnRkVEY-ALeBTIdsk1efBvt4muNbGfhgknsHS814vLJX6kw1WYgccKJ2avgjOgPmPW2ADk6XGNP88a9c3VgP2Mv5LAfDprnn1DRg'

    return (
      <div className="timewise-meeting-content" style={{ height: '100%' }}>
        {/* <iframe
          // src="https://meet.google.com/mcp-wpfb-akv"
          src="https://meet.google.com/mcp-wpfb-akv?hs=151"
          width="800"
          height="600"
          allow="camera; microphone"
          title="Google Meet"
        ></iframe> */}
        <JaaSMeeting
        // <JitsiMeeting
          domain="meet.timewiseid.com"
          appId={UNIQUE_APP_ID}
          // jwt="eyJraWQiOiJ2cGFhcy1tYWdpYy1jb29raWUtZDhlYjAyNzgyZmRhNDBkMDg5ZmQxZTA0MGQzMTgxOTEvN2E0MWNkLVNBTVBMRV9BUFAiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiJqaXRzaSIsImlzcyI6ImNoYXQiLCJpYXQiOjE3Mzg3MzEzNDYsImV4cCI6MTczODczODU0NiwibmJmIjoxNzM4NzMxMzQxLCJzdWIiOiJ2cGFhcy1tYWdpYy1jb29raWUtZDhlYjAyNzgyZmRhNDBkMDg5ZmQxZTA0MGQzMTgxOTEiLCJjb250ZXh0Ijp7ImZlYXR1cmVzIjp7ImxpdmVzdHJlYW1pbmciOnRydWUsIm91dGJvdW5kLWNhbGwiOnRydWUsInNpcC1vdXRib3VuZC1jYWxsIjpmYWxzZSwidHJhbnNjcmlwdGlvbiI6dHJ1ZSwicmVjb3JkaW5nIjp0cnVlfSwidXNlciI6eyJoaWRkZW4tZnJvbS1yZWNvcmRlciI6ZmFsc2UsIm1vZGVyYXRvciI6dHJ1ZSwibmFtZSI6ImRldiIsImlkIjoiYXV0aDB8Njc5ZGQwYWI0MzE2ZjRkMDZmYzk2NTVlIiwiYXZhdGFyIjoiIiwiZW1haWwiOiJkZXZAb25laHViLm5ldCJ9fSwicm9vbSI6IioifQ.aClVnnJ6Ww4mGwcPPzccXHkETVbe4cTRTBPhtq9EDZzvxApVfAcaQGYtWMFH1lMKDFpLVFRhYsP2nNuroHDH1LAAt5O3RnyXctIuK5DHgplxGMQhEQIUNV6D5QOcYxvYXtM6Ayi-NLSdi6C_0Pa8MPG9RzE6o6a1Z5vzAoFhbJ6DVBgKijiehN6QpyGYyozfAitBs5D9UEh4rMaG9-GPLkTProRPnlAu1Z6FiBtEBo1xR2s3TZXnRkVEY-ALeBTIdsk1efBvt4muNbGfhgknsHS814vLJX6kw1WYgccKJ2avgjOgPmPW2ADk6XGNP88a9c3VgP2Mv5LAfDprnn1DRg"
          // roomName={this.props.room.toUpperCase()}
          roomName={this.props.room}
          userInfo={{
            displayName: lib.getFullName(this.myProfile),
            email: this.myProfile?.email,
          }}
          configOverwrite={{
            disableModeratorIndicator: true,
            welcomePage: {
              disabled: false,
            },
            toolbarButtons: JITSI_TOOLBAR_BUTTONS,
            // tidak bekerja
            hideLogo: true,
            defaultLogoUrl: null,
          }}
          interfaceConfigOverwrite={{
            SHOW_CHROME_EXTENSION_BANNER: false,
            // tidak bekerja
            SHOW_BRAND_WATERMARK: false,
            SHOW_JITSI_WATERMARK: false,
            SHOW_WATERMARK_FOR_GUESTS: false,
          }}
          onApiReady={(externalApi) => {
            console.log('onApiReady externalApi', externalApi)

            const closeRecordingMessage = () => message.destroy('recording')

            externalApi.addEventListener('recordingStatusChanged', data => {
              console.log('recordingStatusChanged', data)
              if (data.on)
                message.loading({
                  key: 'recording',
                  duration: 0,
                  content: (
                    <span>
                      [Recording] Don't close meeting before
                      <b> Stop Recording</b>. <span className="link-blue" onClick={closeRecordingMessage}>Hide</span>
                    </span>
                  )
                })
              else
                closeRecordingMessage()

              externalApi.executeCommand('overwriteConfig', {
                toolbarButtons: data.on
                  ? JITSI_TOOLBAR_BUTTONS.filter(val => val !== 'hangup')
                  : JITSI_TOOLBAR_BUTTONS
              })
            })
          }}
          onReadyToClose={this.props.onClose}
          getIFrameRef = {(iframeRef, ...p) => {
            console.log('getIFrameRef', iframeRef, p)
            iframeRef.style.height = '100%'
          }}
          // useStaging
        />
      </div>
    )
  }
}

MeetingContent.propTypes = {
  room: PropTypes.string.isRequired,
  onClose: PropTypes.func,
}

MeetingContent.defaultProps = {
  onClose: () => null,
}

export default MeetingContent